<!--整体布局-->
<template>
  <div class="all-buju fs18 bbox" :style="{ backgroundColor: theme.layout1 }">
    <div class="all-head-box flex ac jb" :style="{ borderBottomColor: theme.layout8 }">
      <img :src="head_logo" class="cr" alt="indexIcon" @click="handleJump2()">
      <div class="popover-box flex ac">
        <el-popover
          ref="popoverRef"
          v-model="popoverVisible"
          placement="bottom-end"
          trigger="hover"
          width="300"
        >
          <template>
            <div class="hover-pop-box cr">
              <p class="bold">积分说明</p>
              <!--              <p>积分用于数字人创作视频、高保真声音克隆等</p>-->
              <!--              <p>· 合成视频10点=1秒；</p>-->
              <!--              <p> · 不足1秒按1秒扣费；</p>-->
              <div v-html="jfContent"></div>
              <div class="flex ac jb">
                <div class="btn1" @click="handleJump(6,'/consum')">积分明细</div>
                <div class="btn2" @click="handleDh">积分兑换</div>
              </div>
            </div>
          </template>
          <template slot="reference">
            <div class="flex ac cr">
              <img class="icon-point-img" src="../assets/pcImages/Icon_Points@2x.png" alt="icon1">
              <p :style="{ color: theme.layout2 }">{{points}}</p>
            </div>
          </template>
        </el-popover>
        <el-popover
          ref="popoverRef2"
          v-model="popoverVisible2"
          placement="bottom-end"
          trigger="hover"
          width="300"
        >
          <template>
            <div class="hover-pop-box cr">
              <div v-if="expire_time">
                <div class="ykt-text">
                  已开通{{site_title}}VIP
                </div>
                <div>会员有效期至 {{expire_time}}</div>
              </div>
              <div v-else>
                <div class="ykt-text">
                  未开通{{site_title}}VIP
                </div>
              </div>
            </div>
          </template>
          <template slot="reference">
            <div class="vip-box cr">
              {{site_title}}VIP
            </div>
          </template>
        </el-popover>
        <el-divider direction="vertical"></el-divider>
        <el-popover
          ref="popoverRef3"
          v-model="popoverVisible3"
          placement="bottom-end"
          trigger="hover"
          width="240"
        >
          <template>
            <div class="er-wei-box cr">
              <p>打开微信扫描下方二维码</p>
              <img :src="qrcode" alt="">
            </div>
          </template>
          <template slot="reference">
            <div class="pc-h5">
              <img :src="theme.layoutIcon15" alt="">
            </div>
          </template>
        </el-popover>
        <div class="notice-icon cr" @click="handleShow">
          <img :src="theme.layoutIcon16" alt="">
        </div>
        <el-popover
          ref="popoverRef4"
          v-model="popoverVisible4"
          placement="bottom-end"
          trigger="hover"
          width="300"
        >
          <template>
            <div class="hover-pop-box cr">
              <p>账号：{{username}}</p>
              <div class="mt20 mb15">
                <p class="mb15">已使用空间{{used}}MB/{{total_format}}G</p>
              </div>
              <div style="width: 100%">
                <!--  <el-progress :percentage="percent" :format="formatProgress"></el-progress>-->
                <el-progress :text-inside="true" :stroke-width="18" :percentage="percent"
                             status="success"></el-progress>
              </div>
              <p style="margin: 15px 0" v-if="is_tourist!=1" @click.stop="handleKr">空间扩容</p>
              <p style="margin: 15px 0" @click.stop="handleDh">积分兑换</p>
              <p style="margin: 0" @click.stop="handleReset">修改密码</p>
              <p @click.stop="handleJump(6,'/consum')">使用详情</p>
              <p @click="handleOut">{{is_tourist==1?'立即登录':'切换账号'}}</p>
            </div>
          </template>
          <template slot="reference">
            <div class="avatar-box cr">
              <img :src="avatar" alt="">
            </div>
          </template>
        </el-popover>
      </div>
    </div>
    <div class="all-info-box flex jb bbox">
      <div class="left-nav-box cr" :style="{ borderRightColor: theme.layout6 }">
        <div class="flex ac every-nav" @click="handleJump(0,'/')"
             :style="{ color: navState==0 ? theme.layout4 : theme.layout2, backgroundColor: navState==0 ? theme.layout5 : ''}">
          <img v-if="navState==0" :src="theme.layoutIcon1" alt="">
          <img v-else :src="theme.layoutIcon2" alt="">
          <p class="pp1">首页</p>
        </div>
        <div class="pp2" :style="{ color: theme.layout3 }">
          功能
        </div>

        <div class="flex ac every-nav" @click="handleJump(11,'/helper/index')" v-if="yyShow"
             :style="{ color: navState==11 ? theme.layout4 : theme.layout2, backgroundColor: navState==11 ? theme.layout5 : ''}">
          <img v-if="navState==11" :src="theme.layoutIcon25" alt="">
          <img v-else :src="theme.layoutIcon26" alt="">
          <p class="pp1">超级助手</p>
        </div>

        <div class="flex ac every-nav" @click="handleJump(1,'/create')"
             :style="{ color: navState==1 ? theme.layout4 : theme.layout2, backgroundColor: navState==1 ? theme.layout5 : ''}">
          <img v-if="navState==1" :src="theme.layoutIcon3" alt="">
          <img v-else :src="theme.layoutIcon4" alt="">
          <p class="pp1">视频创作</p>
        </div>

        <div class="flex ac every-nav" @click="handleJump(2,'/profile')"
             :style="{ color: navState==2 ? theme.layout4 : theme.layout2, backgroundColor: navState==2 ? theme.layout5 : ''}">
          <img v-if="navState==2" :src="theme.layoutIcon5" alt="">
          <img v-else :src="theme.layoutIcon6" alt="">
          <p class="pp1">我的分身</p>
        </div>
        <!--        <div class="flex ac every-nav" :class="navState==7?'actvie':''" @click="handleJump(7,'gProfile')">-->
        <!--          <img v-if="navState==7" src="../assets/pcImages/Left_Icon_Home2@2x.png" alt="">-->
        <!--          <img v-else src="../assets/pcImages/Left_Icon_Home1@2x.png" alt="">-->
        <!--          <p class="pp1">公共形象</p>-->
        <!--        </div>-->
        <div class="flex ac every-nav" @click="handleJump(3,'/clone')"
             :style="{ color: navState==3 ? theme.layout4 : theme.layout2, backgroundColor: navState==3 ? theme.layout5 : ''}">
          <img v-if="navState==3" :src="theme.layoutIcon7" alt="">
          <img v-else :src="theme.layoutIcon8" alt="">
          <p class="pp1">人声克隆</p>
        </div>
        <div class="flex ac every-nav"
             :style="{ color: navState==4 ? theme.layout4 : theme.layout2, backgroundColor: navState==4 ? theme.layout5 : ''}"
             @click="handleJump(4,'/multiples')">
          <img v-if="navState==4" :src="theme.layoutIcon17" alt="">
          <img v-else :src="theme.layoutIcon18" alt="">
          <p class="pp1">批量场景</p>
        </div>

        <!--        <div class="flex ac every-nav"-->
        <!--             :style="{ color: navState==7 ? theme.layout4 : theme.layout2, backgroundColor: navState==7 ? theme.layout5 : ''}"-->
        <!--             @click="handleJump(7,'/pet')">-->
        <!--          <img v-if="navState==7" :src="theme.layoutIcon19" alt="">-->
        <!--          <img v-else :src="theme.layoutIcon20" alt="">-->
        <!--          <p class="pp1">宠物视频</p>-->
        <!--        </div>-->

        <div class="flex ac every-nav"
             :style="{ color: navState==10 ? theme.layout4 : theme.layout2, backgroundColor: navState==10 ? theme.layout5 : ''}"
             @click="handleJump(10,'/explosiveAnalysis')">
          <img v-if="navState==10" :src="theme.layoutIcon23" alt="">
          <img v-else :src="theme.layoutIcon24" alt="">
          <p class="pp1">超级复刻</p>
        </div>

        <div class="flex ac every-nav" v-if="!yyShow"
             :style="{ color: navState==13 ? theme.layout4 : theme.layout2, backgroundColor: navState==13 ? theme.layout5 : ''}"
             @click="handleJump(10,'/employee')">
          <img v-if="navState==13" :src="theme.layoutIcon29" alt="">
          <img v-else :src="theme.layoutIcon30" alt="">
          <p class="pp1">超级员工</p>
        </div>

<!--        <div class="flex ac every-nav"-->
        <!--             :style="{ color: navState==15 ? theme.layout4 : theme.layout2, backgroundColor: navState==15 ? theme.layout5 : ''}"-->
        <!--             @click="handleJump(15,'/cozeVideo')">-->
        <!--          <img v-if="navState==15" :src="theme.layoutIcon31" alt="">-->
        <!--          <img v-else :src="theme.layoutIcon32" alt="">-->
        <!--          <p class="pp1">AI一键爆款</p>-->
        <!--        </div>-->

        <div class="pp2" :style="{ color: theme.layout3 }">
          视频
        </div>
        <div class="flex ac every-nav" @click="handleJump(5,'/works')"
             :style="{ color: navState==5 ? theme.layout4 : theme.layout2, backgroundColor: navState==5 ? theme.layout5 : ''}">
          <img v-if="navState==5" :src="theme.layoutIcon9" alt="">
          <img v-else :src="theme.layoutIcon10" alt="">
          <p class="pp1">我的作品</p>
        </div>

        <div class="flex ac every-nav" @click="handleJump(12,'/material/index')"
             :style="{ color: navState==12 ? theme.layout4 : theme.layout2, backgroundColor: navState==12 ? theme.layout5 : ''}">
          <img v-if="navState==12" :src="theme.layoutIcon27" alt="">
          <img v-else :src="theme.layoutIcon28" alt="">
          <p class="pp1">我的素材</p>
        </div>

        <div class="pp2" :style="{ color: theme.layout3 }">
          其他
        </div>


        <div class="flex ac every-nav" @click="handleJump(6,'/consum')"
             :style="{ color: navState==6 ? theme.layout4 : theme.layout2, backgroundColor: navState==6 ? theme.layout5 : ''}">
          <img v-if="navState==6" :src="theme.layoutIcon11" alt="">
          <img v-else :src="theme.layoutIcon12" alt="">
          <p class="pp1">消费中心</p>
        </div>
        <div class="flex ac every-nav" @click="handleJump(8,'/use')"
             :style="{ color: navState==8 ? theme.layout4 : theme.layout2, backgroundColor: navState==8 ? theme.layout5 : ''}">
          <img v-if="navState==8" :src="theme.layoutIcon13" alt="">
          <img v-else :src="theme.layoutIcon14" alt="">
          <p class="pp1">使用指南</p>
        </div>

        <div class="flex ac every-nav" @click="handleJump(9,'/store')"
             :style="{ color: navState==9 ? theme.layout4 : theme.layout2, backgroundColor: navState==9 ? theme.layout5 : ''}">
          <img v-if="navState==9" :src="theme.layoutIcon21" alt="">
          <img v-else :src="theme.layoutIcon22" alt="">
          <p class="pp1">AI创作全家桶</p>
        </div>


      </div>
      <div class="right-info-box">
        <router-view></router-view>
      </div>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="ruleForm-box">
          <el-form-item label="新密码" prop="password">
            <el-input v-model="ruleForm.password" placeholder="请输入至少6位，数字+字母组合" type="password" autocomplete="off"
                      show-password/>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirm">
            <el-input v-model="ruleForm.confirm" placeholder="请输入至少6位，数字+字母组合" type="password" autocomplete="off"
                      show-password/>
          </el-form-item>
          <el-form-item>
            <p style="color: red">重置密码成功后将退出本次登录重新登录</p>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>

      </div>
    </el-dialog>
    <el-dialog
      title="积分兑换"
      :visible.sync="dialogVisible2"
      width="30%"
    >
      <div>
        <el-input v-model="code" placeholder="请输入积分兑换码"/>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible2 = false">取 消</el-button>
    <el-button type="primary" @click="submitDh">确 定</el-button>
  </span>
    </el-dialog>
    <div class="notic-dailog-box">
      <el-dialog
        :visible.sync="dialogVisible3"
        width="75%"
      >
        <div class="notice-box cr">
          <div class="flex ac jb">
            <div class="notice-left">
              <div class="every-notice1">
                消息中心
              </div>
              <div v-for="(item,index) in noticeList" :key="index" class="every-notice" @click="showNotice(item)">
                <p class="fs14 bold">{{item.title}}</p>
                <p class="fs12" style="margin: 4px 0">{{item.desc}}</p>
                <p class="fs12">{{item.create_time}}</p>
              </div>
            </div>
            <div class="notice-right flex1">
              <div class="fs24 bold mb10">{{title}}</div>
              <div class="fs14">{{create_time}}</div>
              <div v-html="content"></div>
            </div>
          </div>

        </div>
      </el-dialog>
    </div>


  </div>
</template>
<script>
  import {changePwd, credits, space, cdkey, site, notice, spaceExpand, delVideo, creditsRule} from '../api/user'
  import { mapActions } from 'vuex'
  import _ from 'lodash';
  import {throttle} from "../../utils";


  export default {
    name: '',
    watch: {
      '$route'(to, from) {
        // console.log('路由变化了');
        // console.log('当前页面路由：' + to.path);
        // console.log('上一个路由：' + from.path);
        this.checkNav(to.path)
      }
    },
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      },
      points() {
        return this.$store.getters.getPoints;
      },
      yyShow() {
        const currentDomain = window.location.hostname;
        // 允许显示的域名列表
        const allowedDomains = ['koubo123.com', 'qh.koubo123.com','yanyu.qhagent.cn','qhagent.cn'];
        return allowedDomains.includes(currentDomain);
        // return true;
      },
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'))
        } else {
          if (this.ruleForm.password !== '') {
            this.$refs.ruleForm.validateField('confirm')
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入新密码'))
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入新密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        navState: 0,
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        popoverVisible: null,
        popoverVisible2: null,
        popoverVisible3: null,
        popoverVisible4: null,
        popoverVisible5: null,
        avatar: '',
        expire_time: '',
        is_tourist: 1,
        username: '',
        percent: 0,
        used: 0,
        total: 0,
        can_expand: 0,
        total_format: null,
        code: '',
        ruleForm: {
          // old_pass: '',
          password: '',
          confirm: ''
        },
        head_logo: '',
        rules: {
          old_pass: [{required: true, message: '请填写原密码', trigger: 'change'}],
          password: [
            {validator: validatePass, trigger: 'blur'}
          ],
          confirm: [
            {validator: validatePass2, trigger: 'blur'}
          ]
        },
        keywords: '',
        description: '',
        title: '',
        create_time: '',
        content: '',
        jfContent: '',
        noticeList: [],
        icp: '',
        gabeian: '',
        copyright: '',
        cert: '',
        safety_cert: '',
        site_title: '',
        qrcode: '',
      }
    },
    created() {
      this.getCredits()
      this.getSpace()
      this.getSite()
      this.getNotice()
      this.getCreditsRule()
      if (this.$route.path.indexOf('home') > -1) {
        this.navState = 0
      }
      if (this.$route.path.indexOf('create') > -1) {
        this.navState = 1
      }
      if (this.$route.path.indexOf('profile') > -1) {
        this.navState = 2
      }
      if (this.$route.path.indexOf('clone') > -1) {
        this.navState = 3
      }
      if (this.$route.path.indexOf('works') > -1) {
        this.navState = 5
      }
      if (this.$route.path.indexOf('consum') > -1) {
        this.navState = 6
      }
      if (this.$route.path.indexOf('pet') > -1) {
        this.navState = 9
      }
      if (this.$route.path.indexOf('use') > -1) {
        this.navState = 8
      }
      if (this.$route.path.indexOf('multiples') > -1) {
        this.navState = 4
      }
      if (this.$route.path.indexOf('establishPet') > -1) {
        this.navState = null
      }
      if (this.$route.path.indexOf('store') > -1) {
        this.navState = 9
      }
      if (this.$route.path.indexOf('explosive') > -1) {
        this.navState = 10
      }
      if (this.$route.path.indexOf('helper') > -1) {
        this.navState = 11
      }
      if (this.$route.path.indexOf('/material') > -1) {
        this.navState = 12
      }
      if (this.$route.path.indexOf('/employee') > -1) {
        this.navState = 13
      }
      if (this.$route.path.indexOf('/cozeVideo') > -1) {
        this.navState = 15
      }
      this.updatePoints()
      // if (localStorage.getItem('navId')) {
      //   this.navState = localStorage.getItem('navId')
      // } else {
      //   this.navState = 0
      // }
    },
    methods: {
      ...mapActions(['updatePoints']),
      formatProgress(percentage) {
        // 这里可以返回你想要的格式，例如保留两位小数
        return `${percentage.toFixed(2)}%`;
      },
      getCredits() {
        credits({}).then(res => {
          this.username = res.data.username
          this.avatar = res.data.avatar
          this.expire_time = res.data.expire_time
          this.is_tourist = res.data.is_tourist
        })
      },
      getNotice() {
        notice().then(res => {
          this.noticeList = res.data
          if (res.data[0] && res.data[0].id) {
            this.getNoticeDetails(res.data[0].id)
          }
        })
      },
      getCreditsRule() {
        creditsRule().then(res => {
          this.jfContent = this.changeText(res.data.content)
        })
      },

      showNotice(item) {
        this.getNoticeDetails(item.id)
      },
      getNoticeDetails(id) {
        notice({
          id: id
        }).then(res => {
          this.title = res.data.title
          this.create_time = res.data.create_time
          this.content = this.changeText(res.data.content)
        })
      },
      changeText(val) {
        const imageRegex = /<img((?![^>]*?style)[^>]*)>/gi;
        const replacedText = val.replace(imageRegex, (match) => {
          return `<img ${match.slice(0, -1)} style="width: 100%;">`;
        });
        return replacedText;
      },
      // 获取配置
      getSite() {
        site().then(res => {
          this.head_logo = res.data.head_logo ? res.data.head_logo : require('../assets/pcImages/Logo@2x.png')
          this.keywords = res.data.seo_keyword;
          this.description = res.data.seo_desc;

          this.site_title = res.data.site_title ? res.data.site_title : 'AI超级分身'
          this.icp = res.data.icp
          this.gabeian = res.data.gabeian
          this.copyright = res.data.copyright
          this.cert = res.data.cert
          this.safety_cert = res.data.safety_cert

          this.qrcode = res.data.qrcode ? res.data.qrcode : require('../assets/pcImages/qcCode.png')

          // this.avatar = res.data.avatar ? res.data.avatar :'https://oss.xingchaoyiqing.com/html/base/images/home/avatar.png'

        })
      },
      getSpace() {
        space({}).then(res => {
          this.used = res.data.used
          this.total = res.data.total
          // this.percent = (res.data.used / res.data.total).toFixed(2) * 100
          this.percent = parseFloat(((res.data.used / res.data.total) * 100).toFixed(2))
          this.can_expand = res.data.can_expand
          // G（单位）
          this.total_format = res.data.total_format
        })
      },
      handleShowMore() {
        this.$router.push('/moreCredits')
      },
      handleJump(val, path) {
        // if(val==99){
        //   this.$message('陆续上线，敬请期待！');
        //   return false
        // }
        this.popoverVisible = false
        this.popoverVisible2 = false
        this.popoverVisible3 = false
        this.popoverVisible4 = false
        this.navState = val
        localStorage.setItem('navId', val)
        this.$router.push(path)
      },
      handleJump2() {
        if (this.$route.path != '/home') {
          localStorage.setItem('navId', 0)
          this.$router.push('/')
        }
      },
      handleShow() {
        if (this.noticeList.length <= 0) {
          this.$message.error('暂无公告！')
        } else {
          this.dialogVisible3 = true
        }
      },
      // 扩容
      handleKr() {
        if (this.can_expand == 0) {
          this.$message.error('您已扩容至上限！')
          return false
        }
        const that = this
        that.$confirm('此操作将使用5000积分兑换5G扩容空间, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          spaceExpand({}).then(res => {
            if (res) {
              that.$message.success('兑换成功')
            }
            that.getSpace()
          }).catch(error => {
            that.$message.error(error.msg)
          })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消扩容'
          })
        })
      },
      handleDh() {
        if (this.is_tourist == 1) {
          this.$router.push({
            path: '/login',
            query: {
              state: 2
            }
          })
        } else {
          this.dialogVisible2 = true
        }
      }, handleReset() {
        this.dialogVisible = true
      },
      submitDh() {
        cdkey({code: this.code}).then(res => {
          this.$message.success('您已成功兑换' + res.data.credits + '积分')
          this.code = ''
          this.getCredits()
          this.dialogVisible2 = false
        })
      },
      // 退出登录
      handleOut() {
        this.popoverVisible = false
        this.popoverVisible2 = false
        window.localStorage.removeItem('xcToken')
        this.$router.replace({path: '/login'})
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            changePwd(this.ruleForm).then(res => {
              // this.$message.success(res.msg)
              if (res.msg) {
                this.$message.success(res.msg)
              } else {
                this.$message.success('操作成功！')
              }
              window.localStorage.removeItem('xcToken')
              // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
              if (window.location.hash) {
                const url = window.location.hash.split('#')[1]
                // window.localStorage.setItem('redirectUrl', url)
                this.$router.push({
                  path: '/login',
                  query: {
                    redirectUrl: url
                  }
                })
              }
            }).catch(error => {
                this.$message.error(error.msg)
              }
            )
          } else {
            return false
          }
        })
      },
      // 根据路由判断navState
      checkNav(val) {
        if (val.indexOf('/home') > -1) {
          this.navState = 0
        }
        if (val.indexOf('/create') > -1) {
          this.navState = 1
        }
        if (val.indexOf('/profile') > -1) {
          this.navState = 2
        }
        if (val.indexOf('/gProfile') > -1) {
          this.navState = 7
        }
        if (val.indexOf('/clone') > -1) {
          this.navState = 3
        }
        if (val.indexOf('/works') > -1) {
          this.navState = 5
        }
        if (val.indexOf('/consum') > -1) {
          this.navState = 6
        }
        if (val.indexOf('/pet') > -1) {
          this.navState = 9
        }
        if (val.indexOf('/store') > -1) {
          this.navState = 9
        }
        if (val.indexOf('/explosive') > -1) {
          this.navState = 10
        }
        if (val.indexOf('/helper') > -1) {
          this.navState = 11
        }
        if (val.indexOf('/material') > -1) {
          this.navState = 12
        }
        if (val.indexOf('/employee') > -1) {
          this.navState = 13
        }
        if (val.indexOf('/cozeVideo') > -1) {
          this.navState = 15
        }
        localStorage.setItem('navId', this.navState)
      },
      changeTitle() {
        site().then(res => {
          const title = res.data.title
          if (title) {
            document.title = title;
          }
        })
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
      this.changeTitle()
    },
    metaInfo() {
      return {
        meta: [
          {name: 'keywords', content: this.keywords},
          {name: 'description', content: this.description}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .all-buju {
    width: 100vw;
    height: 100vh;
    background: #f3f4fb;
    overflow: hidden;
    box-sizing: border-box;

    .all-head-box {
      width: 100vw;
      height: 56px;
      padding: 0 50px;
      /*background: #0D1027;*/
      /*box-shadow: 0px 1px 0px 0px rgba(250,250,250,0.1);*/
      border-bottom: 1px solid;

      img {
        width: 123px;
        height: 22px;
      }
    }

    .all-info-box {
      width: 100vw;
      height: calc(100vh - 56px);

      .left-nav-box {
        position: relative;
        padding: 16px !important;
        height: 100%;
        width: 200px;
        /*color: #FAFAFA;*/
        overflow-y: scroll;
        overflow-x: hidden;
        border-right: 1px solid;
        /*background: #0D1027;*/
        box-shadow: 1px 0px 0px 0px rgba(250, 250, 250, 0.15);

        .every-nav {
          box-sizing: border-box;
          padding: 0 10px;
          font-size: 14px;
          width: 176px;
          height: 40px;
          border-radius: 8px;
          color: #FAFAFAAA;

          .pp1 {
            margin-left: 13px;
          }

          img {
            width: 22px;
            height: 22px;
          }
        }

        .actvie {
          background-color: #6C14FF !important;
          color: #FFFFFF !important;
        }

        .pp2 {
          height: 20px;
          font-size: 12px;
          color: #5b647a;
          display: block;
          margin: 16px 0 4px 10px;
        }

        .beian-box {
          position: absolute;
          bottom: 10px;
        }
      }

      .right-info-box {
        width: 1720px;
        height: calc(100vh - 95px - 50px);
        color: #FFFFFF;
        border-right: 1px rgba(250, 250, 250, 0.1) solid;
      }
    }
  }


  .popover-box {
    color: #FAFAFA;
    font-size: 14px;

    .hover-pop-box {
      padding: 0 30px;

      .top-pop-box {
        border-bottom: 1px #999999 solid;
      }

      .btn1, .btn2 {
        width: 120px;
        height: 36px;
        background: #FFFFFF;
        border-radius: 4px;

        font-weight: 600;
        font-size: 14px;
        color: #666666;
        line-height: 36px;
        text-align: center;
      }

      .btn2 {
        background: #6C14FF;
        color: #FFFFFF;
      }

    }

    .vip-box {
      margin: 0 16px;
      /*width: 120px;*/
      padding: 0 12px;
      height: 32px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 6px;

      font-weight: 500;
      font-size: 14px;
      color: #01FBF5;
      line-height: 32px;
      text-align: center;
      background: linear-gradient(295.1692297190182deg, #6C14FF 0%, #01FBF5 100%);
    }

    .pc-h5 {
      width: 28px;
      height: 28px;
      margin: 0 16px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .er-wei-ma {
      width: 14px;
      height: 14px;
    }

    .notice-icon {
      width: 28px;
      height: 28px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .avatar-box {
      margin-left: 24px;
      width: 36px;
      height: 36px;
      /*border: 1px solid rgba(1, 251, 245, 1);*/
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }

  .icon-point-img {
    width: 18px !important;
    height: 18px !important;
    margin-right: 5px;
  }

  .btn1, .btn2 {
    width: 120px;
    height: 36px;
    background: #F1EBEB;
    border-radius: 4px;

    font-weight: 600;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    text-align: center;
  }

  .btn2 {
    background: #6C14FF;
    color: #FFFFFF;
  }

  .ykt-text {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 8px;
    text-align: left;
    font-style: normal;
    background-image: linear-gradient(to right, #01FBF5, #6C14FF);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    display: inline-block;
  }

  .er-wei-box {
    p {
      font-weight: 600;
      font-size: 16px;
      color: #222222;
      text-align: center;
    }

    img {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
    }
  }

  .notice-box {
    p {
      margin: 0
    }

    height: 65vh;

    .notice-left::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    .notice-left {
      background: #EFF7FD;
      width: 320px;
      height: 65vh;
      overflow: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      .every-notice1 {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        text-align: left;
        padding: 24px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
      }

      .every-notice {
        width: 264px;
        margin: 0 auto;
        padding: 15px 0;
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
      }
    }

    .notice-right::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    .notice-right {
      padding: 40px;
      height: 65vh;
      overflow: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
    }

  }
</style>
<style>
  .left-nav-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .left-nav-box {
    width: 100vw;
    height: 100vh;
    background-size: 100% 100%;
    overflow: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
  }

  .left-nav-box::-webkit-scrollbar {
    width: 0; /* Chrome, Safari 和其他Webkit浏览器 */
    height: 0;
  }

  .notic-dailog-box .el-dialog__header {
    display: none;
  }

  .notic-dailog-box .el-dialog__body {
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout.vue